import TileCardFormatter from 'crm-cards-sdk/card-formatters/TileCardFormatter';
import ExternalTitleCardFormatter from 'crm-cards-sdk/card-formatters/ExternalTitleCardFormatter';
import { CardContainerContextProvider } from 'crm-cards-sdk/internal/CardContainerContext';
import { createContainerContentKey } from './createContainerContentKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CardListContainerFormatter({
  contents,
  containerId,
  CrmContainerContentRenderer,
  topSlot,
  layout,
  observerManager,
  tabIndex,
  CardFormatter
}) {
  const DefaultCardFormatter = CardFormatter || (layout.use === 'external-title' ? ExternalTitleCardFormatter : TileCardFormatter);

  // Setting size to 0 removes the shaded overhang on the top and bottom of the scrollable area
  return /*#__PURE__*/_jsxs(CardContainerContextProvider, {
    value: {
      DefaultCardFormatter,
      reorderable: false,
      observerManager
    },
    children: [topSlot, contents.map(containerOrCard => /*#__PURE__*/_jsx(CrmContainerContentRenderer, {
      content: containerOrCard,
      tabIndex: tabIndex
    }, createContainerContentKey(containerId, containerOrCard)))]
  });
}
export default CardListContainerFormatter;